<template>
  <AppTableControl
    no-export
    @query-debounced="searchName"
    @search-clicked="filteredRole"
  >
    <template #filters>
      <div class="d-flex">
        <b-form-group label="Type" class="mr-3">
          <b-form-select
            v-model="type"
            :options="roleMemberTypes"
            class="form-control-solid"
          >
          </b-form-select>
        </b-form-group>
      </div>
    </template>
  </AppTableControl>
</template>

<script>
import AppTableControl from "@/modules/core/components/shared/filter/AppTableControl";
export default {
  name: "StaffAdminPageTableControl",
  components: { AppTableControl },
  data() {
    return {
      roleMemberTypes: [
        { value: 1, text: "All" },
        { value: 2, text: "Super Admin" },
        { value: 3, text: "Admin" },
        { value: 4, text: "Member" },
      ],
      type: 1,
    };
  },
  beforeDestroy() {
    this.$store.dispatch("changeStaffAdminListRoleFilters", {
      role: 1,
    });
    this.$store.dispatch("changeStaffAdminListNameFilters", {
      name: null,
    });
  },
  methods: {
    filteredRole() {
      console.log("Role: ", this.type);
      this.$store.dispatch("changeStaffAdminListRoleFilters", {
        role: this.type,
      });

      this.fetch();
    },

    /**
     * Search
     * @param name
     */
    searchName(name) {
      console.log("Name", name);

      this.$store.dispatch("changeStaffAdminListNameFilters", {
        name: name,
      });

      this.fetch();
    },

    fetch() {
      this.$store.dispatch("fetchStaffAdminList");
    },
  },
};
</script>

<style scoped></style>
